var _path, _path2, _path3, _path4;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Microsoft = function Microsoft(_ref) {
  var className = _ref.className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: [_path || (_path = /*#__PURE__*/_jsx("path", {
      d: "M11.3958 0.726074H0.726318V11.3956H11.3958V0.726074Z",
      fill: "#F25022"
    })), _path2 || (_path2 = /*#__PURE__*/_jsx("path", {
      d: "M23 0.726074H12.3306V11.3956H23V0.726074Z",
      fill: "#7FBA00"
    })), _path3 || (_path3 = /*#__PURE__*/_jsx("path", {
      d: "M11.3958 12.3301H0.726318V22.9997H11.3958V12.3301Z",
      fill: "#00A4EF"
    })), _path4 || (_path4 = /*#__PURE__*/_jsx("path", {
      d: "M23 12.3301H12.3306V22.9997H23V12.3301Z",
      fill: "#FFB900"
    }))]
  });
};
export default Microsoft;